import { Component, Input } from '@angular/core';
import { ITableColumn } from 'app/main/shared/shared/table/table-column';
import { IPlaybooksItemDTO } from '../../../dto/playbooks-listening.dto';
import { SharedModule } from 'app/main/shared/shared/shared.module';
import { TranslocoModule } from '@jsverse/transloco';

@Component({
  selector: 'app-playbook-guidelines',
  standalone: true,
  imports: [
    TranslocoModule,
    SharedModule
  ],
  templateUrl: './playbook-guidelines.component.html',
  styleUrl: './playbook-guidelines.component.scss'
})
export class PlaybookGuidelinesComponent {
    @Input() dataItem: IPlaybooksItemDTO;
    @Input() columnOptions: ITableColumn;
}
